"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/cardSelectable.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CardSelectable = function CardSelectable(_ref) {
  var _selectableClasses;

  var children = _ref.children,
      onClick = _ref.onClick,
      state = _ref.state,
      id = _ref.id,
      disabled = _ref.disabled,
      className = _ref.className,
      elevation = _ref.elevation;
  var selectableClasses = (_selectableClasses = {
    'selectableOpt-active': state === id,
    // 'selectableOpt-active': state,
    'selectableOpt-disabled': disabled
  }, _defineProperty(_selectableClasses, "card-elevation-".concat(elevation), elevation), _defineProperty(_selectableClasses, "".concat(className), className), _selectableClasses);
  return /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)('selectableOpt', selectableClasses),
    onClick: onClick
  }, children);
};

CardSelectable.propTypes = {
  children: _propTypes.default.element,
  classNames: _propTypes.default.string,
  onClick: _propTypes.default.func,
  state: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]),
  disabled: _propTypes.default.bool,
  elevation: _propTypes.default.string
};
CardSelectable.defaultProps = {
  children: 'Insert component or HTML',
  className: 'default',
  onClick: null,
  state: null,
  id: null,
  disabled: false,
  elevation: null
};
var _default = CardSelectable;
exports.default = _default;